export enum RECORD_LABEL
{
	RAPTURE_RECORDS = "Rapture Records",
	QDANCE_NEXT = "Q-Dance Next",
	UNIFYD_RECORDS = "Unifyd Records",
	NRG_ATTK = "NRG ATTK",
	RELIANZE = "Relianze",
	UNDEFIANT = "Undefiant",
}

export class Artist
{
	name: string;

	spotify: string;
	appleMusic: string;
	itunes: string;
	youtube: string;
	youtubeMusic: string;
	soundCloud: string;
	instagram: string;

	// OPTIONAL
	amazonMusic?: string;
	deezer?: string;
	hardtunes?: string;
	hardstylecom?: string;
	beatport?: string;
	facebook?: string;

	constructor(
		name: string,
		spotify: string,
		appleMusic: string,
		itunes: string,
		youtube: string,
		youtubeMusic: string,
		soundCloud: string,
		instagram: string,

		// OPTIONAL
		amazonMusic = "",
		deezer = "",
		hardtunes = "",
		hardstylecom = "",
		beatport = "",
		facebook = "",
	)
	{
		this.name = name;

		this.spotify = spotify;
		this.appleMusic = appleMusic;
		this.itunes = itunes;
		this.youtube = youtube;
		this.youtubeMusic = youtubeMusic;
		this.soundCloud = soundCloud;
		this.instagram = instagram;

		// OPTIONAL
		this.amazonMusic = amazonMusic;
		this.deezer = deezer;
		this.hardtunes = hardtunes;
		this.hardstylecom = hardstylecom;
		this.beatport = beatport;
		this.facebook = facebook;
	}
}

export class Release
{
	name: string;
	artists: Artist[];
	releaseDate: Date;
	recordLabel : RECORD_LABEL;
	wavLink: string;

	spotify: string;
	appleMusic: string;
	itunes: string;
	youtube: string;
	youtubeMusic: string;
	soundCloud: string;

	// OPTIONAL
	amazonMusic?: string;
	deezer?: string;
	hardtunes?: string;
	hardstylecom?: string;
	beatport?: string;

	constructor(
		name: string,
		artists: Artist[],
		releaseDate: Date,
		recordLabel: RECORD_LABEL,
		wavLink: string,

		spotify: string,
		appleMusic: string,
		itunes: string,
		youtube: string,
		youtubeMusic: string,
		soundCloud: string,

		// OPTIONAL
		amazonMusic = "",
		deezer = "",
		hardtunes = "",
		hardstylecom = "",
		beatport = ""
	)
	{
		this.name = name;
		this.artists = artists;
		this.releaseDate = releaseDate;
		this.recordLabel = recordLabel;
		this.wavLink = wavLink;

		this.spotify = spotify;
		this.appleMusic = appleMusic;
		this.itunes = itunes;
		this.youtube = youtube;
		this.youtubeMusic = youtubeMusic;
		this.soundCloud = soundCloud;

		// OPTIONAL
		this.amazonMusic = amazonMusic;
		this.deezer = deezer;
		this.hardtunes = hardtunes;
		this.hardstylecom = hardstylecom;
		this.beatport = beatport;
	}
}